import React, { FC } from "react";
import { Worker, WorkerWithDiary } from "../../../../../types";
import { Box, IconButton, useTheme } from "@mui/material";
import classes from "./WorkersMain.module.scss";

//削除
import DeleteIcon from "@mui/icons-material/Delete";

type Props = {
  workerList: Array<WorkerWithDiary>;
  setWorkerList: React.Dispatch<React.SetStateAction<WorkerWithDiary[]>>;
};

const WorkersMain: FC<Props> = (props) => {
  const { workerList, setWorkerList } = props;
  const existCount = workerList.filter(
    (worker: WorkerWithDiary) => worker.isDiaryExist
  ).length;
  const theme = useTheme();
  const handleDeleteButtonClick = (workerId: string) => {
    setWorkerList((prevState) =>
      prevState.filter((worker) => worker.workerId !== workerId)
    );
  };

  return (
    <div className={classes.rootContainer}>
      {existCount > 0 && (
        <p style={{ color: theme.palette.foreColor.error }}>
          {`登録済が${existCount}名います`}
        </p>
      )}
      <div className={classes.workerContainer}>
        {workerList.map((worker) => (
          <div
            className={classes.workerContainer}
            key={worker.workerId}
            style={{
              borderRight: `5px solid ${
                !worker.isDiaryExist
                  ? theme.palette.foreColor.success
                  : theme.palette.foreColor.error
              }`,
            }}
          >
            <div className={classes.workerId}>{worker.workerId}</div>
            <div className={classes.workerContents}>
              <div className={classes.workerName}>{worker.workerName}</div>
              <div className={classes.deleteButton}>
                <IconButton
                  component="label"
                  disabled={false}
                  onClick={() =>
                    handleDeleteButtonClick(worker.workerId as string)
                  }
                  sx={{
                    color: "#cccccc",
                    height: 12,
                    width: 12,
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkersMain;
